/**************************************************
 * Nombre:       Seccion_Looks
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Checkroom, ManageSearch} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_FALS_VERDADERO,
    CASILLA_FECHA_DATO,
    CASILLA_IMG
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import Dialogo_Looks from "../Dialogos/Dialogo_Looks";


const Seccion_Looks = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'looks'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Looks,
        titulo: 'Detalles del Looks',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Looks'}
                        descripcion={`${numeroFilas} fotos en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Looks

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Imagen',
        direccion: 'left',
        propiedad: 'img',
        size: 60,
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Coleccion',
        direccion: 'left',
        propiedad: 'coleccion',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'En Home',
        direccion: 'left',
        propiedad: 'home',
        tipo: CASILLA_FALS_VERDADERO
    },
    {
        nombre: 'Num Prendas',
        direccion: 'left',
        propiedad: 'productos',
        tipo: CASILLA_CONTAR_ARR
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Prendas',
        id: 'prendas',
        icono: Checkroom
    }
]


